<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1AdgHRi/tc-custom/9781504086240.jpg?1734579727950" alt="This image is the cover for the book Bad Wife"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Bad Wife
      </h1>
      <p class="bookDescription body article font2">
        <b>A married woman’s lust for a stranger compels her to risk everything, in this new suspense by the bestselling author of <i>His Other Woman</i>.</b><br/><br/> It’s just a small picture in the local paper—Katie can’t explain why it sets her heart racing. But hiding the photo of local GP Joe Harvey in her bag sets in motion a chain of events that will dramatically alter her life forever.<br/><br/> Driven by a unhealthy desire for a man she hardly knows, the mother of two begins to worm her way into Joe’s life, knowing it’s reckless but still unable to control herself. As her obsession intensifies, Katie’s world becomes increasingly stressful and she’s forced to cover her tracks by lying to everyone around her. Katie’s dancing with danger, and there will be consequences. And while she can’t live without him, Joe barely knows she exists . . . yet.<br/><br/><b>Praise for Sarah Edghill’s <i>A Thousand Tiny Disappointments</i></b><br/><br/> “Thoroughly gripping . . . Sarah Edghill knows how to pinpoint what goes on in families.” —Rachel Joyce, author of <i>The Unlikely Pilgrimage of Harold Fry</i><br/><br/> “Accomplished . . . characters you can relate to.” —Katie Fforde, author of <i>A Country Escape</i><br/><br/> “Compelling.” —Hannah Persaud, author of <i>The Codes of Love</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sarah Edghill
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Bloodhound Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?d68d1658